function buildBtnCtaMarkup(text) {
  const chars = [...text];
  let charIndex = 0;

  return chars
    .map((char) => {
      if (char === ' ') {
        return '<span class="btn_cta__char btn_cta__char--space"> </span>';
      }

      const currentIndex = charIndex;
      charIndex += 1;
      return `<span class="btn_cta__char" style="--char-index: ${currentIndex}">${char}</span>`;
    })
    .join('');
}

function initBtnCta(root = document) {
  root.querySelectorAll('.btn_cta:not([data-cta-ready])').forEach((button) => {
    const label = button.querySelector('.btn_cta__label');
    const target = label || button;
    const text = (label ? label.textContent : button.textContent).trim();
    if (!text) return;

    button.setAttribute('data-cta-ready', 'true');
    target.innerHTML = `<span class="btn_cta__text">${buildBtnCtaMarkup(text)}</span>`;
  });
}

document.addEventListener('DOMContentLoaded', () => initBtnCta());
document.addEventListener('shopify:section:load', (event) => initBtnCta(event.target));
